import { Days, HorairesDTO } from "cadendar-shared";
import { formaters } from "vincent-utils";

export interface HoraireColPropDisplay {
  plages: HorairesDTO["horaire"][Days];
  jour: Days;
}

const HoraireColDisplay = (props: HoraireColPropDisplay) => {
  const isOpen = !!props.plages?.length && props.plages.length > 0;
  return (
    <div
      className={
        "flex flex-1 flex-col justify-center rounded-xl p-3 text-center " +
        (isOpen
          ? "bg-[linear-gradient(180deg,#f9fcff_0%,#eef5ff_100%)]"
          : "flex items-center justify-center bg-[#eceff3]")
      }
    >
      {isOpen ? (
        <>
          {props.plages!.map((plage, idx) => (
            <div
              className="mb-3 flex flex-col gap-1 rounded-[10px] border border-[#eadfb3] bg-[#fff7dc] p-2.5 last:mb-0"
              key={
                formaters.getHourAsMinutesFromHMObject(plage.start).toString() +
                formaters.getHourAsMinutesFromHMObject(plage.end).toString()
              }
            >
              <span className="text-xs uppercase tracking-[0.04em] text-[#8d7442]">
                De
              </span>
              <div
                className="font-bold text-[#4b3c19]"
                data-test={"plageStart" + props.jour + idx}
              >
                {formaters.formatHourMinuteObjectForDisplay(plage.start)}
              </div>
              <span className="text-xs uppercase tracking-[0.04em] text-[#8d7442]">
                A
              </span>
              <div
                className="font-bold text-[#4b3c19]"
                data-test={"plageEnd" + props.jour + idx}
              >
                {formaters.formatHourMinuteObjectForDisplay(plage.end)}
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="font-semibold text-[#5f6b7a]">Ferm&eacute;</div>
      )}
    </div>
  );
};

export default HoraireColDisplay;
